export default "__VITE_ASSET__2eCKrplw__"